import { render, staticRenderFns } from "./section-oxygen-minus-table.vue?vue&type=template&id=1f0fec34&scoped=true"
import script from "./section-oxygen-minus-table.vue?vue&type=script&lang=js"
export * from "./section-oxygen-minus-table.vue?vue&type=script&lang=js"
import style0 from "./section-oxygen-minus-table.vue?vue&type=style&index=0&id=1f0fec34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0fec34",
  null
  
)

export default component.exports